import React from 'react'
import styled, { css } from 'styled-components'
import _ from 'lodash'

import { ConfigBar, EditorContainer } from 'plugin-assets/shared/widget/components/styled'
import PreviewAndData from 'plugin-assets/shared/widget/multi-channel/editor/preview-and-data'

import { ImageLogConfig } from '../../../types/image-log'
import { ASSET_LOOKUP } from '../../../utils/constants'
import ConfigForm, { StyledConfigForm } from './ConfigForm'

type ConfigProps = {
    onChange: (field: string, value: unknown) => void
    onChangeLayoutConfig: (field: string, value: unknown) => void
    config: LiveWidgetConfig<ImageLogConfig>
    widgetConfig: LiveWidgetConfig<ImageLogConfig>
    isEditor?: boolean
}

export default function AssetEditorFactory(
    widgetConfigStore: Record<string, any>,
    widgetConfigActions: Record<string, any>,
    widgetDataStore: Record<string, any>,
    widgetDataActions: Record<string, any>,
    meta: Array<any>
) {
    return function EditorWrapper(props): React.ReactNode {
        return (
            <ImageLogEditor
                widgetConfigStore={widgetConfigStore}
                widgetDataActions={widgetDataActions}
                widgetConfigActions={widgetConfigActions}
                widgetDataStore={widgetDataStore}
                meta={meta}
                {...props}
            />
        )
    }
}

const ImageLogEditor: React.FC<ConfigProps> = (props: ConfigProps) => {
    const selectedAsset = props.filters?.applied?.lookupValues?.[ASSET_LOOKUP]
    const isEmpty = !selectedAsset

    return (
        <Container className="editor-container default-editor">
            <ConfigBar>
                <ConfigForm
                    changeConfig={props.widgetConfigActions.changeConfig}
                    changeLayoutConfig={props.widgetConfigActions.changeLayoutConfig}
                    widgetConfig={props.data.jsonConfig}
                    isEditor={true}
                />
            </ConfigBar>
            <PreviewAndData
                widgetConfigStore={props.widgetConfigStore}
                widgetConfigActions={props.widgetConfigActions}
                widgetDataStore={props.widgetDataStore}
                widgetDataActions={props.widgetDataActions}
                widget={props.data}
                renderPreview={props.renderPreview}
                isEmpty={isEmpty}
                isAssetSelected={!isEmpty}
                meta={props.meta}
            />
        </Container>
    )
}

const Container = styled(EditorContainer)`
    ${StyledConfigForm} {
        height: 100%;
    }
`
